import React, { useState } from 'react';
import Kicker from '../ui/Kicker';
import Button from '../ui/Button';

const FORMSPREE_ENDPOINT = 'https://formspree.io/f/mrbqnvda';

export default function Contact() {
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error

  // Submit over AJAX so the visitor stays on the page and gets feedback in
  // place. The endpoint is unchanged, so submissions land where they always did.
  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;
    setStatus('sending');

    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });

      if (response.ok) {
        form.reset();
        setStatus('sent');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section id="contact" aria-label="Contact Briva">
      <div className="container">
        <div className="cta-box reveal">
          <div className="section-head centered" style={{ marginBottom: 28 }}>
            <Kicker>Let&apos;s talk</Kicker>
            <h2 className="section-title">Start a conversation</h2>
            <p className="section-sub">
              Tell us where you are stuck. We will tell you whether AI is the answer —
              and what it would actually take.
            </p>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="field">
              <label htmlFor="contact-name">Name</label>
              <input id="contact-name" name="name" type="text" required autoComplete="name" />
            </div>

            <div className="field">
              <label htmlFor="contact-email">Email</label>
              <input
                id="contact-email"
                name="email"
                type="email"
                required
                autoComplete="email"
                placeholder="you@company.com"
              />
            </div>

            <div className="field">
              <label htmlFor="contact-message">What are you working on?</label>
              <textarea id="contact-message" name="message" rows="4" required />
            </div>

            <Button type="submit" variant="primary" size="large" disabled={status === 'sending'}>
              {status === 'sending' ? 'Sending…' : 'Send message'}
            </Button>
          </form>

          {status === 'sent' && (
            <p className="form-message success" role="status">
              Thanks — we&apos;ll be in touch shortly.
            </p>
          )}
          {status === 'error' && (
            <p className="form-message error" role="alert">
              Something went wrong. Email us directly at office@briva.one.
            </p>
          )}

          <p className="contact-direct">
            Or reach us directly at{' '}
            <a href="mailto:office@briva.one">office@briva.one</a>
          </p>
        </div>
      </div>
    </section>
  );
}
